<script lang="ts">
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import type { HTMLInputAttributes } from "svelte/elements";
  import cn from "classnames";

  // https://github.com/sveltejs/eslint-plugin-svelte/issues/348
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface $$Props extends HTMLInputAttributes {
    value: string;
  }

  export let value = "";

  const dispatch = createEventDispatcher<{
    value: { value: string };
  }>();

  let element: HTMLInputElement;

  function onInput(event: Event) {
    const target = event.currentTarget as HTMLInputElement;
    dispatch("value", { value: target.value });
  }

  onMount(() => {
    element.addEventListener("input", onInput);
  });

  onDestroy(() => {
    element.removeEventListener("input", onInput);
  });
</script>

<input
  {...$$restProps}
  class={cn("form-input", $$props.class)}
  bind:value
  bind:this={element}
  on:input
  on:change
  on:focus
  on:blur
/>
